// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Components Imports
import FieldsSidebar from "./FieldsSidebar";
import FieldsListing from "./FieldsListing";
import DataStudio from "../DataStudio";

// Internal Imports
import { FIELDS } from "../../constants";

import { fetchFormFields } from "../../actions/FieldsSetting/fieldsSettingActions";

// Destructuring
const { FIELDS_LISTING, DATA_STUDIO } = FIELDS;

class FieldsWrapper extends React.Component {
  state = {};

  componentDidMount() {
    this.props.fetchFormFields();
  }

  // decide the setting view
  _decideSettingsView = currentView => {
    switch (currentView) {
      case FIELDS_LISTING:
        return <FieldsListing />;
      case DATA_STUDIO:
        return <DataStudio />;
      default:
        return <FieldsListing />;
    }
  };

  render() {
    return (
      <div className="fields-wrapper container-fluid">
        <div className="row">
          <FieldsSidebar {...this.props} />
          <div className="fields-view col-md-10">
            {this._decideSettingsView(this.props.view.fieldView)}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchFormFields,
};

export default connect(null, mapDispatchToProps)(FieldsWrapper);
